export default {
  optionList: {
    NetBuyVol: 'KL Mua Ròng',
    NetSellVol: 'KL Bán Ròng',
    NetBuyVal: 'GT Mua Ròng',
    NetSellVal: 'GT Bán Ròng',
  },
};
